/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Spin,
  Card,
  Tabs,
  message,
  Grid,
  DatePicker,
  Tag,
  Typography,
} from 'antd';
import {
  EnvironmentOutlined,
  InfoCircleOutlined,
  QuestionCircleOutlined,
  CameraOutlined,
  FieldTimeOutlined,
  AlertOutlined,
  SearchOutlined,
  EllipsisOutlined,
  CloseCircleOutlined,
  FileDoneOutlined,
  IdcardOutlined,
  PrinterOutlined,
  DeleteOutlined,
} from '@ant-design/icons';
import Direccion from 'components/Direccion';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import { onError } from 'utils/handlers';
import { isMutable } from 'utils/estadosGlobales';
import makeMessager from 'utils/complexFormsMessages';
import NumericInput from 'components/NumericInput';
import { InputSearchPro } from 'components/InputSearch';
import BusquedaAvanzadaPadron from 'views/Recaudacion/Caja/BusquedaAvanzadaPadrones';
import { makeGetOnFinish, makeOnChangeTabKey } from 'utils/tabsManagement';
import { getModelPermission } from 'utils/permission/index';
import Previewer from 'components/Previewer';
import HistorialDePlacasMotos, { model as modelPlacas } from 'components/Catalogos/HistorialDePlacasMotocicleta';
import DocumentosVehiculares, { model as modelDocumentosVehiculares } from 'components/Catalogos/DocumentosVehiculares';
import AlertasDelVehiculo, { model as modelAlertas, catalogsModels } from 'components/Catalogos/AlertasDelVehiculo';
import {
  getCatalogoDePaises,
  getDocumentosDeRegularizacion,
  getTiposDeCombustibles,
  getMarcasDeMotocicletas,
  getUsosDeMotocicletas,
  getDocumentosParaMotocicletas,
  getTiposDeTramitesVehiculares,
} from 'api/catalogos';
import {
  getColoresVehiculos, getServiciosDelVehiculo, getEstadosDeVehiculo, getTiposDeMotocicletas,
} from 'api/recaudacion';
import {
  deleteMotocicleta,
  getMotocicleta,
  getMotocicletas,
  patchMotocicleta,
  postMotocicleta,
} from 'api/recaudacion/motocicletas';
import { getCiudadano } from 'api/cuentaunicasir';
import { patchCiudadano } from 'api/cuentaunicasir/ciudadanos';
import { getUnidadesDeRecaudacion } from 'api/configuracion/unidadesDeRecaudacion';
import { getContribuyente, getContribuyenteCaja } from 'api/empresas/contribuyentes';
import checkToken from 'api/utils/checkToken';
import ModalTramiteMotocicletas from 'components/Catalogos/ModalTarjetaMotos';
import { DATE_FRONTEND_FORMAT } from 'utils/formatValues';
import { getCiudadanoCaja } from 'api/cuentaunicasir/index';
import Moment from 'moment';
import { capitalize, noSymbolsCapitalized } from 'utils/normalizers';
import WidgetPlaca from 'components/widgetPlaca';

const { TabPane } = Tabs;
const { useBreakpoint } = Grid;
const baseURI = 'recaudacion/motocicletas/';

const Motocicleta = ({ permission, addressPermission }) => {
  const estadosGlobales = useSelector(({ catalogs }) => catalogs.estadosGlobales);
  const _entidad = useSelector(({ auth }) => auth.entidad);

  const [form] = Form.useForm();
  const [formSearch] = Form.useForm();
  const [formInfo] = Form.useForm();
  const [formDocumentos] = Form.useForm();
  const esForaneo = Form.useWatch('es_vehiculo_nacional', formInfo);
  const [visibleTarjeta, setVisibleTarjeta] = useState(false);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [mutable, setMutable] = useState(true);
  const [currentTabKey, setCurrentTabKey] = useState('general');
  const [formAddress, setFormAddress] = useState();
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState({ results: [] });
  const [ciudadanoFound, setCiudadanoFound] = useState([]);
  const [documentoParaMotocicleta, setDocumentoParaMotocicleta] = useState([]);
  const [contribuyenteFound, setContribuyenteFound] = useState([]);
  const [base64, setBase64] = useState();
  const [unidadRecaudadora, setUnidadRecaudadora] = useState([]);
  const [isCiudadano, setIsCiudadano] = useState(false);
  const [visiblePreview, setVisiblePreview] = useState(false);
  const [clavesDeDocumento, setClavesDeDocumento] = useState([]);
  const [visibleBusquedaPadrones, setVisibleBusquedaPadrones] = useState(false);
  const [dataExterno, setDataExterno] = useState({ results: [] });
  const [usos, setUsos] = useState([]);
  const [color, setColor] = useState([]);
  const [servicios, setServicios] = useState([]);
  const [permissions, setPermissions] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [tipoDeCombustible, setTipoDeCombustible] = useState([]);
  const [estadoDelVehiculo, setEstadoDelVehiculo] = useState([]);
  const [tiposDeMotocicletas, setTiposDeMotocicletas] = useState([]);
  const [tiposDeTramites, setTiposDeTramites] = useState([]);
  const [paisesTemp, setPaisesTemp] = useState({ results: [] });
  const [marcasTemp, setMarcasTemp] = useState({ results: [] });
  const [visiblePlaca, setVisiblePlaca] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [justView, setJustView] = useState(false);
  const paises = useRef({ results: [] });
  const marcas = useRef({ results: [] });

  const basicKeys = [
    'general',
    'detalles',
    'info',
    'documentos',
    'placas',
    'alertas',
    'facturacion',
  ];
  const complexForms = [
    {
      key: 'direccion',
      formInstance: formAddress,
      permission: addressPermission,
    }];

  const screen = useBreakpoint();

  const fetchData = async (page = 1, q = null) => {
    setLoading(true);
    setCurrentPage(page);
    const _data = await getMotocicletas({
      ...q,
      page,
    });
    setData(_data);
    setLoading(false);
  };

  const showMsg = makeMessager(setCurrentTabKey, fetchData);

  const onCancel = () => {
    setVisible(false);
    formSearch.resetFields();
    form.resetFields();
    formInfo.resetFields();
    formDocumentos.resetFields();
    setContribuyenteFound([]);
    setSelectedRowKeys([]);
    setCurrentTabKey('general');
    setMutable(true);
    setCiudadanoFound([]);
    setBase64();
    setData({ results: [] });
    setJustView(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estados,
        _servicios,
        _unidadRecaudadora,
        _documentosDeRegularizacion,
        _usos,
        _documentosParaMotocicleta,
        _combustibles,
        _colores,
        _tiposDeTramitesVehiculares,
        _tiposDeMoto,
      ] = await Promise.all([
        getEstadosDeVehiculo(),
        getServiciosDelVehiculo(),
        getUnidadesDeRecaudacion(),
        getDocumentosDeRegularizacion(),
        getUsosDeMotocicletas(),
        getDocumentosParaMotocicletas(),
        getTiposDeCombustibles(),
        getColoresVehiculos(),
        getTiposDeTramitesVehiculares(),
        getTiposDeMotocicletas(),
      ]);
      if (mounted) {
        setEstadoDelVehiculo(_estados);
        setServicios(_servicios);
        setClavesDeDocumento(_documentosDeRegularizacion);
        setUnidadRecaudadora(_unidadRecaudadora);
        setUsos(_usos);
        setDocumentoParaMotocicleta(_documentosParaMotocicleta);
        setTipoDeCombustible(_combustibles);
        setColor(_colores);
        setTiposDeTramites(_tiposDeTramitesVehiculares);
        setTiposDeMotocicletas(_tiposDeMoto);
        setLoading(false);
      }
    };
    const validatePermissions = () => {
      const documentosVehiculares = getModelPermission(modelDocumentosVehiculares);
      const alertas = getModelPermission(modelAlertas, catalogsModels);
      const placas = getModelPermission(modelPlacas);
      if (mounted) {
        setPermissions({
          documentosVehiculares,
          alertas,
          placas,
        });
      }
    };
    validatePermissions();
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const fetchCiudadano = async (id) => {
    setLoading(true);
    if (id) {
      const _ciudadano = await getCiudadano(id);
      if (_ciudadano) {
        setCiudadanoFound([_ciudadano]);
      } else {
        message.info('No se encontró ciudadano');
      }
    }
    setLoading(false);
  };

  const fetchContribuyente = async (id) => {
    setLoading(true);
    if (id) {
      const _contribuyente = await getContribuyente(id);
      if (_contribuyente) {
        setContribuyenteFound([_contribuyente]);
      } else {
        message.info('No se encontró el Contribuyente');
      }
    }
    setLoading(false);
  };

  const onClickEdit = async (response) => {
    form.resetFields();
    formInfo.resetFields();
    formDocumentos.resetFields();
    const key = response?.id || selectedRowKeys[0];
    const match = await getMotocicleta(key);
    setMutable(isMutable(match.estados_globales));
    setIsCiudadano(match.es_propietario_ciudadano);
    if (match) {
      if (match?.propietario) {
        const propietario = match.propietario?.id || match.propietario;
        await fetchCiudadano(propietario);
        match.propietario = propietario;
      }
      if (match?.contribuyente_propietario) {
        const propietario = match.contribuyente_propietario?.id || match.contribuyente_propietario;
        await fetchContribuyente(propietario);
        match.contribuyente_propietario = propietario;
      }
      const _paises = await getCatalogoDePaises({ id: match?.pais });
      setPaisesTemp(_paises);
      const _marca = await getMarcasDeMotocicletas({ id: match?.marca });
      setMarcasTemp(_marca);
    }
    setTimeout(() => {
      form.setFieldsValue({ ...match });
      formInfo.setFieldsValue({ ...match });
      formDocumentos.setFieldsValue(match);
      setVisible(true);
      setIsEditing(true);
    });
  };

  const setBaseAndShowPreview = (_base64) => {
    setBase64(_base64);
    setVisiblePreview(true);
  };

  const handleSearch = async () => {
    try {
      setLoading(true);
      await formSearch.validateFields();
      const params = formSearch.getFieldsValue();
      const keys = Object.keys(params);
      const validProps = keys.filter((prop) => params[prop]);
      if (validProps.length) {
        const _data = await getMotocicletas(params);
        setData(_data);
      } else {
        message.warn('Debe ingresar al menos un campo.');
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const wipe = () => {
    formSearch.resetFields();
    setData({ results: [] });
  };

  const content = (
    <>
      <Row justify="end">
        <Button
          type="link"
          style={{ color: '#000000', marginTop: -25 }}
          icon={<CloseCircleOutlined />}
          onClick={() => message.destroy()}
        />
      </Row>
      <strong>Hace falta buscar un propietario.</strong>
      <br />
      <span>
        Para buscar un propietario ubiquese en la pestaña
        {' '}
        <Tag
          icon={<InfoCircleOutlined style={{ color: '#000000', margin: 0 }} />}
          onClick={() => {
            setCurrentTabKey('info');
            message.destroy();
          }}
        >
          Información del Vehículo
        </Tag>
        seleccione a que padrón pertenece (Contribuyente o Ciudadano) y en el
        campo ubicado
        a la derecha introduzca algún dato del padrón correspondiente y presione el icono
        de búsqueda (
        <SearchOutlined style={{ color: '#000000', margin: 0 }} />
        ), en caso de que no se arroje alguna coincidencia presione el botón (
        <EllipsisOutlined style={{ color: '#000000', margin: 0 }} />
        ) para realizar una búsqueda avanzada.
      </span>
    </>
  );

  const onFinish = async (_continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      await formInfo.validateFields();
      await formDocumentos.validateFields();
      const values = {
        ...form.getFieldsValue(),
        ...formInfo.getFieldsValue(),
        ...formDocumentos.getFieldsValue(),
      };
      if (values.es_vehiculo_nacional) {
        values.pais = 152;
      }
      if (isCiudadano) {
        values.contribuyente_propietario = null;
      } else {
        values.propietario = null;
      }
      if (values?.exento_de_pago_de_tenencia) {
        values.tipo_de_tenencia_vehicular = null;
      }

      if ((isCiudadano && !values?.propietario)
        || (!isCiudadano && !values?.contribuyente_propietario)) {
        message.info({ content, duration: 0 });
      } else {
        const [key] = selectedRowKeys;
        if (key) {
          values.fecha_del_ultimo_movimiento = new Moment();
        }
        const response = await (key
          ? patchMotocicleta(key, values) : postMotocicleta(values));
        if (response) {
          if (_continue) {
            if (!key) {
              setSelectedRowKeys([response.id]);
              onClickEdit(response);
              if (response?.comprobante) {
                setBaseAndShowPreview(response?.comprobante);
              }
            } else {
              onClickEdit(response);
            }
          } else {
            onCancel();
          }
        }
      }
      setLoading(false);
      return true;
    } catch (err) {
      if (err?.errorFields?.length) {
        if (err.errorFields.some((e) => e.name[0] === 'q')) {
          message.info({ content, duration: 0 });
        }
      }
      onError(err, setLoading, [form, formInfo, formDocumentos], setCurrentTabKey);
      return false;
    }
  };

  const deleteItem = async () => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const deleted = await deleteMotocicleta(key);
    if (deleted) {
      setVisibleAlert(false);
      onCancel();
    }
    setLoading(false);
  };

  const handleOnRowClick = (record) => {
    setMutable(isMutable(record));
    setSelectedRowKeys([record.id]);
    setTimeout(() => {
      form.setFieldsValue({ ...record });
      formInfo.setFieldsValue(record);
      formDocumentos.setFieldsValue(record);
    });
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const columns = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 150,
    },
    {
      titleText: 'Placa',
      dataIndex: 'numero_de_placa_vigente',
      key: 'numero_de_placa_vigente',
      width: 150,
    },
    {
      titleText: 'Serial',
      dataIndex: 'serie',
      key: 'serie',
      width: 200,
    },
    {
      titleText: 'Modelo',
      dataIndex: 'modelo',
      key: 'modelo',
      width: 200,
    },
    {
      titleText: 'Uso',
      dataIndex: 'uso_de_la_motocicleta',
      key: 'uso_de_la_motocicleta',
      width: 300,
      catalog: {
        cat: usos,
        labelProp: 'descripcion',
        use: true,
      },
    },
    {
      titleText: 'Color',
      dataIndex: 'color_del_vehiculo',
      key: 'color_del_vehiculo',
      width: 200,
      catalog: {
        cat: color,
        labelProp: 'descripcion',
        use: true,
      },
    },
    {
      titleText: 'Registro Público',
      dataIndex: 'registro_publico_vehicular',
      key: 'registro_publico_vehicular',
      width: 200,
    },
    {
      titleText: 'Estado',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 100,
      render: (e) => estadosGlobales.find((i) => i.id === e)?.descripcion,
    },
  ];

  const rules = {
    required: [{ required: true }],
    archivos: [
      {
        validator: async () => {
          const { factura_del_vehiculo, pedimento_del_vehiculo } = formInfo.getFieldsValue();
          if (factura_del_vehiculo?.fileList?.length
            && pedimento_del_vehiculo?.fileList?.length) {
            throw new Error('Solo es necesario la factura o el pedimento');
          }
        },
      },
    ],
  };

  const resetAndValidate = () => {
    setContribuyenteFound([]);
    setCiudadanoFound([]);
    formInfo.resetFields(['q']);
    formInfo.validateFields(['q']);
  };

  const searchCiudadano = async () => {
    try {
      setLoading(true);
      await form.validateFields(['q']);
      const { q } = form.getFieldsValue(['q']);
      if (q) {
        const _ciudadanos = await getCiudadanoCaja({ q });
        if ([1].includes(_ciudadanos.results.length)) {
          const [selected] = _ciudadanos.results;
          form.setFieldsValue({
            propietario: selected.id,
          });
          setCiudadanoFound([selected]);
        } else if (_ciudadanos.results.length > 1) {
          setDataExterno(_ciudadanos);
          setVisibleBusquedaPadrones(true);
        } if (!_ciudadanos.results.length) {
          message.info('No se encontró ciudadano');
        }
      } else {
        await form.validateFields(['q']);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onChangeTabKey = makeOnChangeTabKey(
    basicKeys,
    complexForms,
    currentTabKey,
    setCurrentTabKey,
    showMsg,
  );

  const getOnFinish = makeGetOnFinish(basicKeys, complexForms, currentTabKey, onFinish);

  const searchContribuyente = async () => {
    try {
      setLoading(true);
      await form.validateFields(['q']);
      const { q } = form.getFieldsValue(['q']);
      if (q) {
        const _contribuyente = await getContribuyenteCaja({ q });
        if (_contribuyente?.results?.length === 1) {
          const [selected] = _contribuyente.results;
          form.setFieldsValue({
            contribuyente_propietario: selected.id,
          });
          setContribuyenteFound([selected]);
        } else if (_contribuyente.results.length > 1) {
          setDataExterno(_contribuyente);
          setVisibleBusquedaPadrones(true);
        } if (!_contribuyente.results.length) {
          message.info('No se encontró contribuyente');
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const perteneceOptions = [
    {
      id: true,
      descripcion: 'Ciudadano',
    },
    {
      id: false,
      descripcion: 'Contribuyente',
    },
  ];

  const allowSearch = screen.md || screen.lg || screen.xl || screen.xxl;

  const asignarEntidad = async (user) => {
    setLoading(true);
    const { razon_social } = _entidad;
    const { entidad, nombre_completo, id } = user;
    entidad.push(entidad.id);
    await patchCiudadano(
      id,
      { entidad },
      `Ahora el usuario ${nombre_completo} también pertenece a ${razon_social}.`,
    );
    setLoading(false);
  };

  const msgAsignarEntidad = (user) => (
    message.info({
      content: (
        <>
          <Row style={{ width: '100%' }}>
            El contribuyente no pertenece a la entidad.
          </Row>
          <Row justify="center">
            <strong style={{ marginRight: 3 }}>
              ¿Desea asignarlo a esta entidad?
            </strong>
          </Row>
          <Row align="middle" justify="center" style={{ width: '100%' }}>
            <Button
              type="link"
              onClick={() => asignarEntidad(user)}
            >
              Si
            </Button>
            <Button
              onClick={() => {
                message.destroy();
                form.resetFields();
              }}
              type="link"
            >
              No
            </Button>
          </Row>
        </>

      ),
      duration: 0,
    })
  );

  return (
    <Row align="center" justify="center" className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!visible && (
        <>
          <Form
            layout="vertical"
            form={formSearch}
            scrollToFirstError
            onFinish={() => handleSearch()}
          >
            <Row gutter={10}>
              <Col xs={24} sm={24} md={6}>
                <Form.Item
                  label="Clave"
                  name="clave"
                  normalize={capitalize}
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item
                  label="Número de Placa"
                  name="numero_de_placa_vigente"
                  normalize={capitalize}
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item
                  name="serie"
                  label="Serie"
                  tooltip="Número de Serie de la Motocicleta"
                  normalize={capitalize}
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item
                  label="Registro Publico"
                  name="registro_publico_vehicular"
                  normalize={capitalize}
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Button
                  onClick={handleSearch}
                  block
                  style={{ marginTop: 21 }}
                >
                  <SearchOutlined />
                  <Typography.Text>
                    Buscar
                  </Typography.Text>
                </Button>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Button
                  onClick={wipe}
                  block
                  style={{ marginTop: 21 }}
                >
                  <DeleteOutlined />
                  <Typography.Text>
                    Limpiar Busqueda
                  </Typography.Text>
                </Button>
              </Col>
            </Row>
          </Form>
          <Table
            cols={columns}
            data={data?.results}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            customActions={[
              {
                onClick: () => setVisibleTarjeta(true),
                icon: <PrinterOutlined />,
                text: 'Imprimir Tajerta de Circulacion',
                disabledBySelection: true,
              },
            ]}
            controls={{
              onClickAdd,
              onClickEdit,
              onClickDelete,
              onClickExpand: () => {
                setJustView(true);
                onClickEdit();
              },
            }}
            rowKey="id"
            baseURI={baseURI}
            allowImport
            allowExpand
            mobileColIndex={0}
            allowColumnSelector={false}
            allowSearch={allowSearch}
            permission={permission}
            pagination={false}
            paginationCallback={fetchData}
            count={data.count}
            currentPage={currentPage}
          />
        </>
        )}
        {visible && (
          <Col span={24}>
            <Card
              className="form-container"
              title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Motocicleta`}
              extra={(
                <FormSubmitControls
                  onFinish={justView ? null : getOnFinish()}
                  onCancel={onCancel}
                  mutable={mutable}
                  allowSaveAndContinue={!justView}
                  onCancelText="Cancelar"
                  permission={permission}
                />
              )}
              bordered={false}
            >
              <Tabs
                onChange={mutable ? onChangeTabKey : setCurrentTabKey}
                activeKey={currentTabKey}
                type="card"
              >
                <TabPane
                  tab={(
                    <span>
                      <IdcardOutlined />
                      Información General
                    </span>
                  )}
                  key="general"
                  forceRender
                >
                  <Form
                    name="general"
                    layout="vertical"
                    form={form}
                    onFinish={() => onFinish()}
                    scrollToFirstError
                    initialValues={{ estados_globales: 1 }}
                  >
                    <Row gutter={10}>
                      {!!selectedRowKeys.length && (
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="clave"
                            label="Clave"
                            hasFeedback
                            allowClear
                          >
                            <Input disabled />
                          </Form.Item>
                        </Col>
                      )}
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="numero_de_placa_vigente"
                          label="Número de Placa"
                          hasFeedback
                          normalize={capitalize}
                        >
                          <Input allowClear maxLength={10} disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                      {isEditing && (
                        <Col xs={24} sm={24} md={8}>
                          <Button
                            onClick={() => {
                              setVisiblePlaca(true);
                            }}
                            block
                            style={{ marginTop: 21 }}
                          >
                            Agregar Placa
                          </Button>
                        </Col>
                      )}
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="serie"
                          label="Serial"
                          hasFeedback
                          rules={rules.required}
                        >
                          <Input allowClear maxLength={40} disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="tarjeta_de_circulacion"
                          label="Número de Tarjeta de Circulación"
                          hasFeedback
                        >
                          <Input allowClear disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="numero_calcomania"
                          label="Número de Calcomanía"
                          hasFeedback
                        >
                          <Input allowClear disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="clave_nacional"
                          label="Clave Nacional"
                          hasFeedback
                        >
                          <Input allowClear disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="es_propietario_ciudadano"
                          label="Pertenece a"
                          hasFeedback
                          rules={rules.required}
                        >
                          <Select
                            dataSource={perteneceOptions}
                            onChange={(value) => {
                              setIsCiudadano(value);
                              resetAndValidate();
                            }}
                            disabled={!mutable || justView}
                          />
                        </Form.Item>
                      </Col>
                      {isCiudadano ? (
                        <InputSearchPro
                          disabled={!mutable || justView}
                          tooltip="Búsqueda por correo"
                          label="Ciudadano Propietario"
                          name="q"
                          rules={rules.required}
                          onClickAdvanced={() => setVisibleBusquedaPadrones(true)}
                          breakPoints={{
                            xs: 24,
                            sm: 24,
                            md: 16,
                          }}
                          inputProps={{
                            onPressEnter: () => searchCiudadano(),
                            onChange: ({ target: { value } }) => {
                              if (!value) {
                                resetAndValidate();
                              }
                            },
                          }}
                          onPressEnter={searchCiudadano}
                          resultProps={{
                            name: 'propietario',
                            label: 'Propietario',
                            dataSource: ciudadanoFound,
                            labelProp: 'nombre_completo',
                            onClear: resetAndValidate,
                            breakPoints: {
                              xs: 24,
                              sm: 24,
                              md: 16,
                            },
                          }}
                        />
                      ) : (
                        <InputSearchPro
                          disabled={!mutable || justView}
                          tooltip="Búsqueda por Nombre Completo"
                          label="Contribuyente Propietario"
                          onClickAdvanced={() => setVisibleBusquedaPadrones(true)}
                          name="q"
                          rules={rules.required}
                          onPressEnter={searchContribuyente}
                          breakPoints={{
                            xs: 24,
                            sm: 24,
                            md: 16,
                          }}
                          inputProps={{
                            onPressEnter: () => searchContribuyente(),
                            onChange: ({ target: { value } }) => {
                              if (!value) {
                                resetAndValidate();
                              }
                            },
                          }}
                          resultProps={{
                            breakPoints: {
                              xs: 24,
                              sm: 24,
                              md: 16,
                            },
                            name: 'contribuyente_propietario',
                            label: 'Contribuyente Propietario',
                            dataSource: contribuyenteFound,
                            labelProp: 'nombre_completo',
                            onClear: resetAndValidate,
                          }}
                        />
                      )}
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="unidad_de_recaudacion"
                          label="Unidad Recaudadora"
                          rules={rules.required}
                        >
                          <Select dataSource={unidadRecaudadora} allowClear />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={16}>
                        <Form.Item
                          name="observaciones"
                          label="Observaciones"
                          hasFeedback
                        >
                          <Input.TextArea
                            autoSize={{ minRows: 3, maxRows: 3 }}
                            allowClear
                            disabled={!mutable || justView}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="fecha_del_ultimo_movimiento"
                          label="Fecha del último movimiento"
                          hasFeedback
                        >
                          <DatePicker
                            placeholder=""
                            format={DATE_FRONTEND_FORMAT}
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="tipo_de_tramite_vehicular"
                          label="Tipo de tramite vehícular"
                          hasFeedback
                        >
                          <Select
                            dataSource={tiposDeTramites}
                            disabled={!mutable || justView}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="estados_globales"
                          label="Estado"
                          hasFeedback
                        >
                          <Select
                            disabled
                            dataSource={estadosGlobales}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Form.Item hidden>
                      <Button htmlType="submit" />
                    </Form.Item>
                  </Form>
                </TabPane>
                <TabPane
                  tab={(
                    <>
                      <InfoCircleOutlined />
                      Información de la Motocicleta
                    </>
                  )}
                  key="info"
                  forceRender
                >
                  <Form
                    name="info"
                    layout="vertical"
                    form={formInfo}
                    onFinish={() => onFinish()}
                    scrollToFirstError
                    initialValues={{
                      es_vehiculo_nacional: false,
                    }}
                  >
                    <Row gutter={10}>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="es_vehiculo_nacional"
                          label="¿Es Nacional?"
                          hasFeedback
                        >
                          <Select
                            trueFalse
                            disabled={!mutable || justView}
                          />
                        </Form.Item>
                      </Col>
                      {!esForaneo && (
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="pais"
                            label="País"
                            hasFeedback
                          >
                            <Select
                              disabled={!mutable || justView}
                              dataSource={paisesTemp.results?.length ? paisesTemp : paises.current}
                              usingExternalDataSource={Boolean(paisesTemp.results?.length)}
                              labelProp="descripcion"
                              onClear={() => {
                                form.resetFields(['pais']);
                                setPaisesTemp({ results: [] });
                              }}
                              pagination={{
                                getter: getCatalogoDePaises,
                                setter: (dataSource) => {
                                  paises.current = dataSource;
                                },
                                config: { auto: true, qName: 'descripcion' },
                              }}
                            />
                          </Form.Item>
                        </Col>
                      )}
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="es_fronterizo"
                          label="¿Es Fronterizo?"
                          hasFeedback
                        >
                          <Select
                            trueFalse
                            disabled={!mutable || justView}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="marca"
                          label="Marca"
                          hasFeedback
                          rules={rules.required}
                        >
                          <Select
                            disabled={!mutable || justView}
                            dataSource={marcasTemp?.length ? marcasTemp : marcas.current}
                            usingExternalDataSource={Boolean(marcasTemp?.length)}
                            labelProp="descripcion"
                            onClear={() => {
                              formInfo.resetFields(['linea', 'version_vehicular']);
                              setMarcasTemp({ results: [] });
                            }}
                            pagination={{
                              getter: getMarcasDeMotocicletas,
                              setter: (dataSource) => {
                                marcas.current = dataSource;
                              },
                              config: { auto: true, qName: 'descripcion' },
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <NumericInput
                          name="modelo"
                          label="Modelo"
                          tooltip={{
                            title: 'Año del vehículo',
                            icon: <QuestionCircleOutlined />,
                          }}
                          required
                          disabled={!mutable || justView}
                        />
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="linea"
                          label="Submarca"
                          hasFeedback
                          rules={rules.required}
                        >
                          <Input
                            allowClear
                            disabled={!mutable || justView}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="tipo_de_motocicleta"
                          label="Tipo de Motocicleta"
                          rules={rules.required}
                        >
                          <Select labelProp="nombre" dataSource={tiposDeMotocicletas} disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="estatus_del_vehiculo"
                          rules={rules.required}
                          label="Estatus de la motocicleta"
                          hasFeedback
                        >
                          <Select
                            dataSource={estadoDelVehiculo}
                            labelProp="nombre"
                            disabled={!mutable || justView}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="servicio"
                          label="Servicio"
                          hasFeedback
                          rules={rules.required}
                        >
                          <Select dataSource={servicios} labelProp="nombre" disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="numero_de_motor"
                          label="Número de motor"
                          hasFeedback
                        >
                          <Input allowClear disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="descripcion_de_la_agencia"
                          label="Agencia Distribuidora"
                          hasFeedback
                          rules={rules.required}
                        >
                          <Input allowClear disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="color_del_vehiculo"
                          label="Color"
                          hasFeedback
                          rules={rules.required}
                        >
                          <Select
                            dataSource={color}
                            disabled={!mutable || justView}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="color_secundario"
                          label="Color Secundario"
                          hasFeedback
                        >
                          <Input
                            allowClear
                            disabled={!mutable || justView}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <NumericInput
                          name="capacidad_del_combustible "
                          label="Capacidad del Tanque"
                          disabled={!mutable || justView}
                          tooltip="Capacidad en litros"
                        />
                      </Col>

                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="uso_de_la_motocicleta"
                          label="Uso de la Motocicleta"
                          hasFeedback
                          rules={rules.required}
                        >
                          <Select dataSource={usos} disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <NumericInput
                          name="cilindraje"
                          label="Cilindraje"
                          disabled={!mutable || justView}
                          decimal
                          required
                        />
                      </Col>

                      <Col xs={24} sm={24} md={8}>
                        <NumericInput
                          name="capacidad_del_cilindraje"
                          label=" Desplazamiento (cc/L)"
                          // tooltip="Capacidad del Cilindraje en cm³"
                          disabled={!mutable || justView}
                          decimal
                          required
                        />
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <NumericInput
                          name="peso_del_vehiculo"
                          label="Peso de la Motocicleta"
                          disabled={!mutable || justView}
                          decimal
                          tooltip="Peso en Kilogramos"
                        />
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <NumericInput
                          name="numero_de_ruedas"
                          label="Número de Ruedas"
                          disabled={!mutable || justView}
                          required
                        />
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="tipo_de_combustible"
                          label="Tipo de Combustible"
                          hasFeedback
                          rules={rules.required}
                        >
                          <Select dataSource={tipoDeCombustible} />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Form.Item hidden>
                      <Button htmlType="submit" />
                    </Form.Item>
                  </Form>
                </TabPane>
                <TabPane
                  tab={(
                    <>
                      <FileDoneOutlined />
                      Facturación
                    </>
                  )}
                  key="facturacion"
                  forceRender={selectedRowKeys.length}
                >
                  <Form
                    name="facturacion"
                    layout="vertical"
                    form={form}
                    onFinish={() => onFinish()}
                    scrollToFirstError
                  >
                    <Row gutter={10}>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="clave_del_documento_de_regularizacion"
                          label="Clave de Documento"
                          hasFeedback
                        >
                          <Select
                            disabled={!mutable || justView}
                            dataSource={clavesDeDocumento}
                            keyLabelRender
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="documentos_para_motocicletas"
                          label="Documento del Tramite"
                          hasFeedback
                        >
                          <Select
                            dataSource={documentoParaMotocicleta}
                            keyLabelRender
                            keyProp="clave"
                            labelProp="descripcion"
                            mode="multiple"
                            disabled={!mutable || justView}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <NumericInput
                          name="importe_de_la_factura"
                          label="Importe de la factura"
                          disabled={!mutable || justView}
                          decimal
                          required
                        />
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="fecha_de_la_factura"
                          label="Fecha de la Factura"
                          hasFeedback
                          rules={rules.required}
                        >
                          <DatePicker placeholder="" format="DD/MM/YYYY" disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="numero_de_factura"
                          label="Número de Factura"
                          hasFeedback
                          rules={rules.required}
                        >
                          <Input allowClear disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="rfc_emisor_cfdi"
                          label="RFC Emisor CFDI"
                          hasFeedback
                          normalize={noSymbolsCapitalized}
                          rules={rules.required}
                        >
                          <Input maxLength={13} allowClear disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="registro_publico_vehicular"
                          label="Registro Público Vehícular"
                          hasFeedback
                        >
                          <Input allowClear maxLength={17} disabled={!mutable || justView} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={24}>
                        <Form.Item
                          name="observaciones_de_factura"
                          label="Observaciones de Factura"
                          hasFeedback
                        >
                          <Input.TextArea
                            autoSize={{ minRows: 3, maxRows: 3 }}
                            allowClear
                            disabled={!mutable || justView}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Form.Item hidden>
                      <Button htmlType="submit" />
                    </Form.Item>
                  </Form>
                </TabPane>
                {addressPermission?.view && (
                  <TabPane
                    tab={(
                      <>
                        <EnvironmentOutlined />
                        Dirección
                      </>
                    )}
                    key="direccion"
                    forceRender
                    disabled={!selectedRowKeys.length}
                  >
                    <Direccion
                      mutable={mutable && !justView}
                      currentURI={baseURI}
                      parentID={selectedRowKeys[0]}
                      setLoading={setLoading}
                      onError={onError}
                      setFormAddress={setFormAddress}
                      setCurrentTabKey={setCurrentTabKey}
                      permission={addressPermission}
                      callback={(values, _continue) => {
                        if (!_continue) {
                          onCancel();
                        } else {
                          const [key] = selectedRowKeys;
                          const clone = [...data];
                          const mappedData = clone.map((e) => (e.id === key
                            ? ({ ...e, direccion: values?.id }) : e));
                          setData(mappedData);
                        }
                      }}
                    />
                  </TabPane>
                )}
                {permissions?.placas?.view && (
                  <TabPane
                    tab={(
                      <>
                        <FieldTimeOutlined />
                        Historial de Placas
                      </>
                    )}
                    key="placas"
                    disabled={!selectedRowKeys.length}
                    forceRender={selectedRowKeys.length}
                  >
                    <HistorialDePlacasMotos
                      motoID={selectedRowKeys[0]}
                      permission={permissions?.placas}
                      esPropietarioCiudadano={isCiudadano}
                      contribuyentePropietario={contribuyenteFound[0]?.id}
                      ciudadanoPropietarioId={ciudadanoFound[0]?.id}
                      setCurrentTabKey={setCurrentTabKey}
                      justView={justView}
                      callback={onClickEdit}
                    />
                  </TabPane>
                )}
                {permissions?.documentos?.view && (
                  <TabPane
                    tab={(
                      <>
                        <CameraOutlined />
                        Fotos
                      </>
                    )}
                    key="documentos"
                    disabled={!selectedRowKeys.length}
                    forceRender={selectedRowKeys.length}
                  >
                    <DocumentosVehiculares
                      vehiculoId={selectedRowKeys[0]}
                      permission={permissions?.documentos}
                    />
                  </TabPane>
                )}
                {permissions?.alertas?.view && (
                  <TabPane
                    tab={(
                      <>
                        <AlertOutlined />
                        Alertas
                      </>
                    )}
                    key="alertas"
                    disabled={!selectedRowKeys.length}
                    forceRender={selectedRowKeys.length}
                  >
                    <AlertasDelVehiculo vehiculoId={selectedRowKeys[0]} />
                  </TabPane>
                )}
              </Tabs>
            </Card>
          </Col>
        )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          visible={visibleAlert}
          content="Motocicleta Seleccionada?"
          loading={loading}
        />
        <Previewer
          visible={visiblePreview}
          setVisible={setVisiblePreview}
          base64={base64}
        />
        <BusquedaAvanzadaPadron
          visible={visibleBusquedaPadrones}
          setVisible={setVisibleBusquedaPadrones}
          callback={(found) => {
            if (isCiudadano) {
              setCiudadanoFound([found]);
              form.setFieldsValue({ propietario: found.id });
            } else {
              setContribuyenteFound([found]);
              form.setFieldsValue({ contribuyente_propietario: found.id });
            }
          }}
          dataExterno={dataExterno}
          setDataExterno={setDataExterno}
          tipoDePadron={isCiudadano ? 1 : 15}
          msgAsignarEntidad={msgAsignarEntidad}
          allowAdd={false}
        />
        <WidgetPlaca
          visible={visiblePlaca}
          setVisible={setVisiblePlaca}
          vehiculoId={selectedRowKeys}
          padronVehicular={16}
          callback={(_vehiculo, _placa) => {
            form.setFieldsValue({
              ..._vehiculo,
              numero_de_placa_vigente: _placa?.numero_de_placa,
            });
          }}
        />
        <ModalTramiteMotocicletas
          visible={visibleTarjeta}
          setVisible={setVisibleTarjeta}
          selectedRowKey={selectedRowKeys[0]}
        />
      </Spin>
    </Row>
  );
};

export default Motocicleta;
